import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FranchiseService } from './franchise.service';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { LoginComponent } from '../login/login.component';
import { HeaderService } from '../header/header.service';
import { Offcanvas } from '../form.offcanvas';
import { ScriptLoader } from '../script-loader';
import { GroupService } from "../groups/groups.service";
import { AppSettings } from "../../config/config";
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;

@Component({
    selector: 'app-schoollist',
    templateUrl: './schoollist.component.html',
    styleUrls: [
        './../../assets/css/theme-default/bootstrap.css',
        './../../assets/css/theme-default/materialadmin.css',
        './../../assets/css/theme-default/font-awesome.min.css',
        './../../assets/css/theme-default/material-design-iconic-font.min.css',
        /* './../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
        './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
        './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
        './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
        './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
        './../../_crop/css/style.css',
        './../../_crop/css/style-example.css',
        './schoollist.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [FranchiseService, LoginService, LoginComponent, Offcanvas, ScriptLoader]
})


export class SchoollistComponent implements OnInit {

    brand = this.brandService.brand;
    constructor(private FranchiseService: FranchiseService, private router: Router,
        private loginservice: LoginService, private logincomponent: LoginComponent,
        private offcanvas: Offcanvas, private scriptLoader: ScriptLoader, private brandService: BrandService) {
    }


    public static gAcademicId = 0;

    getAuthToken = localStorage.getItem('usertoken');
    getSchoolId = localStorage.getItem('schoolinfo');
    getCurrency = localStorage.getItem('currency');

    schoolCardView = true;
    schoolListView = false;
    schoolDetailView = false;

    preLoader = true;
    todayDate;
    getSchoolName;
    getSchoolImage;
    accountType;
    loginMode = '';
    getSchoolListArray = [];

    sId;
    sDomain;
    sImage;
    sName;
    sStudent;
    sStaff;
    sCollected;
    sResource;
    sIsSuspended = 0;

    currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'INR',
    });

    navigateTo(path, data) {
        this.router.navigate(['/' + path], { state: { tab: data } });
    }

    getProperNumber(num) {
        return num < 10 ? '0' + num : num;
    }

    // get today date
    getTodayDate() {
        const getDateNow = new Date();
        const getMonth = getDateNow.getUTCMonth() + 1;
        const getDay = getDateNow.getUTCDate();
        const getYear = getDateNow.getUTCFullYear();

        this.todayDate = getYear + '/' + getMonth + '/' + getDay;

    }

    calculateResourceFee(colleadtedAmount, commissionType, commissionValue) {
        if (commissionType == 'AMOUNT') {
            if (Number(colleadtedAmount) < Number(commissionValue)) {
                return colleadtedAmount;
            }
            else {
                return commissionValue;
            }
        }
        else if (commissionType == 'PERCENTAGE') {

            return Number(colleadtedAmount) * Number(commissionValue) / 100;
        }
        else {
            return 0;
        }
    }


    /*Data table operation*/
    destroyDataTable(table) {
        $('#' + table).DataTable().destroy();
    }

    getTheDomainName(schoolDomain){
        let splitString = location.hostname.split(".");
        splitString[0] = schoolDomain;

        return location.protocol+"//"+ splitString.join(".");
    }

    getSchoolListData() {
        this.FranchiseService.fetchSchoolListData(this.getSchoolId, this.getAuthToken)
            .subscribe(
                (data: any) => {
                    // init script
                    this.initScripts();
                    setTimeout(() => this.initScripts(), 500);
                    for (let i = 0; i < data.length; i++) {
                       
                            this.getSchoolListArray.push(data[i]);
                            this.getSchoolListArray[i].resourceFee = this.calculateResourceFee(data[i].totalCollectedFees, data[i].commissionType, data[i].commissionValue);
                        
                    }
                },
                error =>
                    () => {
                    }
            );
    }

    schoolDetails(id, domain, image, name, student, staff, collected, resource,isSuspended) {
        this.sDomain = domain;
        this.sId = id;
        this.sImage = image;
        this.sName = name;
        this.sStudent = student;
        this.sStaff = staff;
        this.sCollected = collected;
        this.sResource = resource;
        this.sIsSuspended = isSuspended;
        this.schoolDetailView = true;
    }

    closeSchoolDetails() {
        this.schoolDetailView = false;
    }


    // string wrap to words function  
    //getWords(str,5);
    getWords(str, count) {
        return str.split(/\s+/).slice(0, count).join(' ');
    }

    toggleView(val) {
        if (val == "list") {
            this.schoolCardView = false;
            this.schoolListView = true;
        }
        else {
            this.schoolCardView = true;
            this.schoolListView = false;
        }
    }

    numberToCurrency(number) {

        let result = null;

        if (number > 999 && number < 100000) {
            number = number / 1000;
            number = parseFloat(number).toFixed(2);
            result = number + "K";
        }
        else if (number > 99999 && number < 10000000) {
            number = number / 100000;
            number = parseFloat(number).toFixed(2);
            result = number + "L";
        }
        else if (number > 9999999) {
            number = number / 10000000;
            number = parseFloat(number).toFixed(2);
            result = number + "C";
        }
        else {
            result = number;
        }
        return "₹" + result;
    }


    // token auth
    isValidToken() {
        let isValidToken = false;
        let isValidSchool = 0;
        this.loginservice.isValidToken(this.getAuthToken)
            .subscribe(
                (data: any) => {
                    isValidToken = data.isValid;
                    if (data.errorcode === 10010) {
                        this.router.navigate(['/suspended']);
                    } else if (isValidToken === true) {

                        this.loginservice.isValidSchoolId(this.getSchoolId)
                            .subscribe(
                                (validData: any) => {
                                    isValidSchool = validData.schoolExist;
                                    if (isValidSchool !== 1) {
                                        this.router.navigate(['/login']);
                                    }
                                    else {
                                        if (this.loginMode === 'STAFF') {
                                            this.router.navigate(['/exams']);
                                        }
                                        else {
                                            this.getSchoolListData();
                                        }
                                    }
                                },
                                error => {
                                }
                            );
                    } else {
                        this.router.navigate(['/login']);
                    }
                },
                error => {
                }
            );
    }

    visitSchool(domain, id) {
        if(window.location.protocol == "https:"){
            const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
            window.open("https://"+domain+"."+domainSuffix+"/#/login/"+id+"/"+this.getAuthToken);

        }
        else{
            window.open("http://"+domain+".localhost:4200/#/login/"+id+"/"+this.getAuthToken);
        }
    }


    initScripts() {
        this.scriptLoader.loadScript($, 'DASHBOARD');
    }

    ngOnInit() {

        this.isValidToken();

        setTimeout(() => this.initScripts(), 500);
    }




}
